export default "__VITE_ASSET__baaf299a__"